import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import Footer from '../components/Footer';

const TermsConditionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <Button onClick={() => navigate('/')} variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver a la tienda
          </Button>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Términos y Condiciones de Compra</h1>
            <p className="text-sm text-gray-500 mb-8">Última actualización: Febrero 2025</p>

            <div className="prose prose-gray max-w-none space-y-6">
              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">1. Información General</h2>
                <p className="text-gray-600">
                  Las presentes Condiciones Generales de Contratación regulan la relación de venta a distancia entre JRF SPORTSWEAR y el usuario o cliente, de acuerdo con las estipulaciones legales, especialmente la Ley 7/1998 de Condiciones Generales de Contratación, la Ley 3/2014 por la que se modifica el texto refundido de la Ley General para la Defensa de los Consumidores y el Real Decreto 1906/1999 de Contratación Telefónica o Electrónica.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">2. Identificación del Vendedor</h2>
                <ul className="list-disc pl-6 text-gray-600 space-y-1">
                  <li><strong>Denominación:</strong> JRF SPORTSWEAR</li>
                  <li><strong>NIF:</strong> 54372237F</li>
                  <li><strong>Domicilio:</strong> Plaza de la Constitución 15, 29788 Frigiliana (Málaga), España</li>
                  <li><strong>Email:</strong> infojrfsportswear@gmail.com</li>
                  <li><strong>WhatsApp:</strong> +34 611 871 722</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">3. Proceso de Compra</h2>
                <p className="text-gray-600">Para realizar una compra, el usuario deberá seguir los siguientes pasos:</p>
                <ol className="list-decimal pl-6 text-gray-600 space-y-1 mt-3">
                  <li>Seleccionar los productos deseados y añadirlos al carrito</li>
                  <li>Acceder al carrito y verificar los productos seleccionados</li>
                  <li>Introducir los datos de envío y facturación</li>
                  <li>Seleccionar el método de envío</li>
                  <li>Seleccionar el método de pago</li>
                  <li>Revisar y confirmar el pedido</li>
                  <li>Realizar el pago</li>
                </ol>
                <p className="text-gray-600 mt-3">
                  Una vez completado el pago, recibirá un email de confirmación con los detalles del pedido.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">4. Precios</h2>
                <p className="text-gray-600">
                  Todos los precios mostrados en la web incluyen el IVA vigente en España. Los gastos de envío se calcularán y mostrarán antes de la confirmación del pedido.
                </p>
                <p className="text-gray-600 mt-2">
                  JRF SPORTSWEAR se reserva el derecho de modificar los precios en cualquier momento, si bien los productos se facturarán al precio vigente en el momento de realizar el pedido.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">5. Formas de Pago</h2>
                <p className="text-gray-600">Aceptamos los siguientes métodos de pago:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Tarjeta de crédito/débito:</strong> Visa, Mastercard, American Express (procesado por Stripe)</li>
                  <li><strong>PayPal:</strong> Pago seguro con cuenta PayPal</li>
                  <li><strong>Tarjeta Regalo JRF:</strong> Canjeable por el importe de la tarjeta</li>
                </ul>
                <p className="text-gray-600 mt-2">
                  El cargo se realizará en el momento de confirmar el pedido. Todos los pagos se procesan de forma segura mediante cifrado SSL.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">6. Envío y Entrega</h2>
                <p className="text-gray-600"><strong>Zona de envío:</strong> España Peninsular</p>
                <p className="text-gray-600 mt-2"><strong>Transportistas y plazos:</strong></p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li><strong>SEUR:</strong> 24-48 horas laborables - 5,99€</li>
                  <li><strong>Correos Express:</strong> 24-48 horas laborables - 4,99€</li>
                  <li><strong>InPost (punto de recogida):</strong> 48-72 horas laborables - 3,49€</li>
                </ul>
                <p className="text-gray-600 mt-3">
                  <strong>Envío gratuito</strong> en pedidos superiores a 80€.
                </p>
                <p className="text-gray-600 mt-2">
                  Los plazos de entrega son estimados y pueden variar por causas ajenas a JRF SPORTSWEAR. Los pedidos se procesan de lunes a viernes (excepto festivos).
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">7. Derecho de Desistimiento</h2>
                <p className="text-gray-600">
                  De conformidad con la legislación vigente, el usuario tiene derecho a desistir de la compra en un plazo de <strong>14 días naturales</strong> desde la recepción del producto, sin necesidad de justificación.
                </p>
                <p className="text-gray-600 mt-2"><strong>Condiciones para el desistimiento:</strong></p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li>El producto debe estar sin usar, con etiquetas originales</li>
                  <li>Debe estar en su embalaje original o similar</li>
                  <li>No aplica a productos personalizados o íntimos por razones de higiene</li>
                </ul>
                <p className="text-gray-600 mt-3"><strong>Opciones disponibles:</strong></p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li><strong>Cambio de talla/producto:</strong> GRATUITO</li>
                  <li><strong>Tarjeta Regalo:</strong> Por el valor total del producto (GRATUITO)</li>
                  <li><strong>Reembolso:</strong> Se retendrá un 15% del importe en concepto de gastos de gestión y logística</li>
                </ul>
                <p className="text-gray-600 mt-3">
                  Para ejercer el derecho de desistimiento, contacte con nosotros en infojrfsportswear@gmail.com indicando su número de pedido.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">8. Garantía Legal</h2>
                <p className="text-gray-600">
                  Todos nuestros productos están cubiertos por la garantía legal de conformidad de <strong>3 años</strong> según el Real Decreto-ley 7/2021.
                </p>
                <p className="text-gray-600 mt-2">
                  Si el producto presenta algún defecto de fabricación o no es conforme con lo contratado, tiene derecho a:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li>La reparación del producto</li>
                  <li>La sustitución del producto</li>
                  <li>Una reducción del precio</li>
                  <li>La resolución del contrato</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">9. Productos y Disponibilidad</h2>
                <p className="text-gray-600">
                  Los productos ofrecidos en la web están sujetos a disponibilidad. En caso de que un producto no esté disponible tras realizar el pedido, nos pondremos en contacto con usted para ofrecerle alternativas o proceder al reembolso.
                </p>
                <p className="text-gray-600 mt-2">
                  Las fotografías de los productos son orientativas. Pueden existir pequeñas variaciones de color debido a la configuración de su pantalla.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">10. Tarjetas Regalo</h2>
                <ul className="list-disc pl-6 text-gray-600 space-y-1">
                  <li>Las tarjetas regalo no caducan</li>
                  <li>No son reembolsables ni canjeables por dinero</li>
                  <li>Son válidas para cualquier producto de la tienda</li>
                  <li>Se pueden utilizar parcialmente, conservando el saldo restante</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">11. Cupones y Códigos Promocionales</h2>
                <ul className="list-disc pl-6 text-gray-600 space-y-1">
                  <li>Los cupones tienen fecha de caducidad indicada</li>
                  <li>No son acumulables con otras ofertas, salvo indicación expresa</li>
                  <li>Solo se puede utilizar un cupón por pedido</li>
                  <li>JRF SPORTSWEAR se reserva el derecho de cancelar cupones obtenidos de forma fraudulenta</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">12. Atención al Cliente</h2>
                <p className="text-gray-600">
                  Para cualquier consulta, reclamación o incidencia:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li><strong>Email:</strong> infojrfsportswear@gmail.com</li>
                  <li><strong>WhatsApp:</strong> +34 611 871 722</li>
                  <li><strong>Horario:</strong> Lunes a Viernes, 9:00 - 18:00</li>
                </ul>
                <p className="text-gray-600 mt-2">
                  Nos comprometemos a responder en un plazo máximo de 48 horas laborables.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">13. Resolución de Litigios</h2>
                <p className="text-gray-600">
                  En caso de controversia, el usuario puede acudir a la plataforma de resolución de litigios en línea de la UE: 
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-black hover:underline ml-1">
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">14. Ley Aplicable y Jurisdicción</h2>
                <p className="text-gray-600">
                  Las presentes condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los Juzgados y Tribunales del domicilio del consumidor.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
